import { render, staticRenderFns } from "./footNote.vue?vue&type=template&id=04d3e5c4&"
import script from "./footNote.vue?vue&type=script&lang=js&"
export * from "./footNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports